import get from 'lodash/get';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { useMedia } from 'react-media';
import { Container } from 'semantic-ui-react';
import AppHeader from '../../../components/AppHeader';
import AppMenu from '../../../components/menu/AppMenu';
import AppSecondaryMenu from '../../../components/menu/AppSecondaryMenu';
import MenuMobile from '../../../components/menu/MenuMobile';
import { useConfig, useUpdateConfig } from '../../../config/config.context';
import { useDesignConfig } from '../../../config/design.context';
import { useMe } from '../../../profile/hooks';
import { GLOBAL_MEDIA_QUERIES } from '../../../utils/mediaQueries';
import BurgerMenu from '../../VideoBackground/components/BurgerMenu';
import platformService from '../../../core/services/platform.service';
import { useLoginPath } from '../../../config/screens.context';

// TODO : transformer en Menus ?
export const HorizontalMenu = ({ menu }) => {
  const user = useMe();
  const updateConfig = useUpdateConfig();

  const matches = useMedia({ queries: GLOBAL_MEDIA_QUERIES });
  const { lang, languages, menus, debug } = useConfig();
  const loginPath = useLoginPath();

  // TODO: config has already been updated from `ensureConfig` in App
  // This should probably be in GlobalConfigSync and checking for user updates
  useEffect(() => {
    if (debug?.disableConfigSync) return;
    platformService.fetchConfig().then(updateConfig);
  }, [debug?.disableConfigSync, updateConfig, user]);

  const design = useDesignConfig();
  const { menu: menuConfig = {} } = design;
  if (matches.mobile || menuConfig.mobileOnly) {
    return (
      <MenuMobile
        menu={[
          ...menu?.map((m) => ({ ...m, menuType: 'main' })),
          ...get(menus, ['secondary', 'entries'], []).map((m) => ({ ...m, menuType: 'secondary' })),
        ].filter((m) => m.type !== 'search')}
        language={lang}
        languageOptions={languages}
        design={design}
        user={user}
        loginPath={loginPath}
      />
    );
  }

  return (
    <div>
      {matches.desktop && (
        <div className="menu-secondary-wrapper">
          <Container>
            <AppSecondaryMenu menu={menus?.secondary} />
          </Container>
        </div>
      )}
      <div
        className={`menu-wrapper menu-wrapper--${get(menuConfig, 'wrapper.variant', 'logoTop')}`}
      >
        <Container>
          <AppHeader language={lang} languageOptions={languages} />
          {menuConfig?.variant === 'burger' ? (
            <BurgerMenu menu={menu} user={user} menuConfig={menuConfig} loginPath={loginPath} />
          ) : (
            <AppMenu
              menu={menu}
              menuConfig={menuConfig}
              variant={menuConfig?.entries?.variant}
              loginPath={loginPath}
            />
          )}
        </Container>
      </div>
    </div>
  );
};

HorizontalMenu.defaultProps = {
  menu: [],
};

HorizontalMenu.propTypes = {
  menu: PropTypes.arrayOf(PropTypes.object),
};
